module.exports = __webpack_public_path__ + "static/media/vvs-logo~gZIryDhu.59182b44.svg";